// extracted by mini-css-extract-plugin
module.exports = {"SokeSide":"SokeSide_SokeSide__2X854","header":"SokeSide_header__3uxPt","sok":"SokeSide_sok__1_swA"};